module.exports = __webpack_public_path__ + "img/trouble-arrow-sp-tab.41e17bfb.svg";